import { render, staticRenderFns } from "./RegistratieAanmaken.vue?vue&type=template&id=4ee337bf&scoped=true&"
import script from "./RegistratieAanmaken.vue?vue&type=script&lang=js&"
export * from "./RegistratieAanmaken.vue?vue&type=script&lang=js&"
import style0 from "./RegistratieAanmaken.vue?vue&type=style&index=0&id=4ee337bf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee337bf",
  null
  
)

export default component.exports